import admissionActiveIcon from "../assets/admission-active-icon.svg";
import admission from "../assets//admission.svg";
import createPrescription from "../assets//create_prescription.svg";
import formActiveIcon from "../assets//form-active.svg";
import form from "../assets//form.svg";
import insuranceActiveIcon from "../assets//insurance-active-icon.svg";
import insurance from "../assets//insurance.svg";
import prescriptionActive from "../assets//prescription-active-icon.svg";
import prescription from "../assets//prescription.svg";
import receiptActiveIcon from "../assets//receipt-active-icon.svg";
import receipt from "../assets//receipt.svg";
import reportActive from "../assets//report-active-icon.svg";
import report from "../assets//report.svg";
import symptomActiveIcon from "../assets//symptom-active-icon.svg";
import symptom from "../assets//symptom.svg";
import consultationIcon from "../assets//consultation.svg";
import uploadPrescription from "../assets//upload_prescription.svg";
import vaccineActiveIcon from "../assets//vaccineActiveIcon.svg";
import vaccineIcon from "../assets//vaccineIcon.svg";
import vitalActiveIcon from "../assets//vital-active-icon.svg";
import vital from "../assets//vital.svg";

export const Regex = {
  pinCode: /^[1-9][0-9]{5}$/gm,
  aadhaarNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  abhaNumber: /^[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{4}$/,
  phoneNumber: /^\+[1-9]{1}[0-9]{11,14}$/,
  healthId: /^(?=[A-Za-z])(?!.*[._].*[._])[A-Za-z0-9]*[._]?[A-Za-z0-9]+$/,
  // eslint-disable-next-line
  address: /^[A-Za-z0-9\s,.'\/()]+$/,
  password:
    // eslint-disable-next-line
    /^(?!.*(.)\1{2,})(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z0-9!@#$%^&*()_\-=\+\[\]{};:'",.<>?~\\]{8,}$/,
  // password: /^[A-Za-z](?!^\d)(?!.*\.$)[A-Za-z0-9.]{3,}\d?$/,
  // password: /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{4,}$/,
  // eslint-disable-next-line
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  name: /\d/
};

export const defaultFields = [
  {
    type: "string",
    name: "blood group",
    required: true
  },
  {
    type: "string",
    name: "gender",
    required: true
  },
  {
    type: "string",
    name: "allergies",
    required: true
  },
  {
    type: "timestamp",
    name: "date of birth",
    required: true
  },
  {
    type: "float",
    name: "heart rate",
    required: true
  },
  {
    type: "float",
    name: "blood oxygen",
    required: true
  },
  {
    type: "float",
    name: "blood sugar",
    required: true
  },
  {
    type: "float",
    name: "body temperature",
    required: true
  },
  {
    type: "float",
    name: "blood pressure",
    required: true
  },
  {
    type: "float",
    name: "height",
    required: true
  },
  {
    type: "float",
    name: "weight",
    required: true
  }
];

export const dataTypeConversion = (dataType) => {
  if (dataType === "string") {
    return "Alphanumeric (All characters)";
  } else if (dataType === "Alphanumeric (All characters)") {
    return "string";
  } else if (dataType === "float") {
    return "Number (Digits)";
  } else if (dataType === "Number (Digits)") {
    return "float";
  } else if (dataType === "timestamp") {
    return "Date (Date)";
  } else if (dataType === "Date (Date)") {
    return "timestamp";
  } else {
    return "";
  }
};

export function dateAndTimeConverter(timestamp, type) {
  if (!timestamp) return;

  if (type === "cardDate") {
    const dateObject = new Date(timestamp);
    return (
      dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { weekday: "long" }) +
      " "
    );
  }
  if (type === "cardDateWithoutDay") {
    const dateObject = new Date(timestamp);
    return (
      dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { year: "2-digit" }) +
      " "
    );
  }

  if (type === "firstDate") {
    const dateObject = new Date(timestamp);
    return dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase();
  }
  if (type === "secondDate") {
    const dateObject = new Date(timestamp);
    return (
      dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
      " " +
      dateObject.toLocaleString("en-IN", { year: "numeric" })
    );
  }

  if (type === "Time") {
    const dateObject = new Date(timestamp);
    return (
      dateObject
        .toLocaleString("en-IN", {
          hour: "numeric" && "2-digit",
          minute: "numeric" && "2-digit",
          hour12: true
        })
        .toUpperCase() + " "
    );
  }
}

export const convertAbdmToNintoDocumentTypes = (data) => {
  if (data) {
    switch (data) {
      case "OPConsultation":
        return "consultation";
      case "Prescription":
        return "prescription";
      case "DischargeSummary":
        return "admission";
      case "DiagnosticReport":
        return "report";
      case "ImmunizationRecord":
        return "vaccine";
      case "HealthDocumentRecord":
        return "others";
      case "WellnessRecord":
        return "vital";
      case "Invoice":
      case "InvoiceRecord":
        return "invoice";

      default:
        return "others";
    }
  }
  return;
};

export const convertNintoToAbdmDocumentTypes = (data) => {
  if (data) {
    switch (data) {
      case "prescription":
        return "Prescription";
      case "admission":
        return "DischargeSummary";
      case "report":
        return "DiagnosticReport";
      case "vaccine":
        return "ImmunizationRecord";
      case "consultation":
        return "OPConsultation";
      case "invoice":
        return "Invoice";
      case "vital":
        return "WellnessRecord";

      case "others":
        return "HealthDocumentRecord";
      default:
        return "HealthDocumentRecord";
    }
  }
  return;
};

export const convertTimestampToDate = (data) => {
  // 1999-1-30
  return {
    day: parseInt(data.split("-")[2]),
    month: parseInt(data.split("-")[1]),
    year: parseInt(data.split("-")[0])
  };
};

export const getRemainingTime = (expiresAt) => {
  const diffMs = expiresAt - Date.now();

  if (diffMs <= 0) {
    return "";
  }

  const totalMinutes = Math.ceil(diffMs / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    return `${hours} ${hours === 1 ? "hour" : "hours"} ${minutes} ${
      minutes === 1 ? "minute" : "minutes"
    }`;
  }

  if (hours > 0) {
    return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  }

  return `${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
};

export const shareUrl = async ({ title = "", text = "", url = "" }) => {
  if (navigator.share) {
    await navigator.share({ title, text, url });
  } else {
    await navigator.clipboard.writeText(url);
  }
};

export const getMenuItems = (filterState) => {
  const items = [
    {
      type: "symptom",
      text: "Symptom",
      filterMenuText: "Symptoms",
      defaultIcon: symptom,
      activeIcon: symptomActiveIcon,
      dataCy: "upload-symptom-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "prescription",
      text: "Prescription",
      filterMenuText: "Prescriptions",
      defaultIcon: prescription,
      activeIcon: prescriptionActive,
      dataCy: "UPLOAD-PRESCRIPTION-BUTTON",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "report",
      text: "Report",
      filterMenuText: "Reports",
      defaultIcon: report,
      activeIcon: reportActive,
      dataCy: "upload-report-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "receipt",
      text: "Receipt",
      filterMenuText: "Receipts",
      defaultIcon: receipt,
      activeIcon: receiptActiveIcon,
      dataCy: "upload-receipt-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "admission",
      text: "Admission",
      filterMenuText: "Admissions",
      defaultIcon: admission,
      activeIcon: admissionActiveIcon,
      dataCy: "upload-admission-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "insurance",
      text: "Insurance",
      filterMenuText: "Insurances",
      defaultIcon: insurance,
      activeIcon: insuranceActiveIcon,
      dataCy: "upload-insurance-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "uploadPrescription",
      text: "Upload Prescription",
      filterMenuText: "",
      defaultIcon: uploadPrescription,
      activeIcon: uploadPrescription,
      dataCy: "prescription-upload-button",
      widthHeight: "home-add-documents-icon-size"
    },
    {
      type: "createPrescription",
      text: "Create Prescription",
      filterMenuText: "",
      defaultIcon: createPrescription,
      activeIcon: createPrescription,
      dataCy: "create-prescription-button",
      widthHeight: "home-add-documents-icon-size"
    },
    {
      type: "vital",
      text: "Vital",
      filterMenuText: "Vitals",
      defaultIcon: vital,
      activeIcon: vitalActiveIcon,
      dataCy: "UPLOAD-VITAL-BUTTON",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "form",
      text: "Forms",
      filterMenuText: "Forms",
      defaultIcon: form,
      activeIcon: formActiveIcon,
      dataCy: "upload-form-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "vaccine",
      text: "Vaccine",
      filterMenuText: "Vaccines",
      defaultIcon: vaccineIcon,
      activeIcon: vaccineActiveIcon,
      dataCy: "UPLOAD-VACCINE-BUTTON",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "consultation",
      text: "Consultation",
      filterMenuText: "Consultations",
      defaultIcon: consultationIcon,
      activeIcon: consultationIcon,
      dataCy: "upload-consultation-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "invoice",
      text: "Invoice",
      filterMenuText: "Invoices",
      defaultIcon: receipt,
      activeIcon: receiptActiveIcon,
      dataCy: "upload-invoice-button",
      widthHeight: "filter-icon-height-and-width"
    },
    {
      type: "others",
      text: "Other",
      filterMenuText: "Others",
      defaultIcon: receipt,
      activeIcon: receiptActiveIcon,
      dataCy: "upload-others-button",
      widthHeight: "filter-icon-height-and-width"
    }
  ];

  // Map over items to add dynamic icon & alt
  return items.map((item) => {
    const isActive = filterState.documentType.includes(item.type);
    return {
      ...item,
      icon: isActive ? item.activeIcon : item.defaultIcon,
      alt: `${isActive ? "active-" : ""}${item.type}-icon`
    };
  });
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);